/** Translations of the analytics area; wired up in lib/i18n/en.ts. */
export const analyticsTr = {
  title: 'Analizler',
  subtitle: 'Serbestçe seçilebilen dönemlere göre gelir, katkı marjı ve müşteri yapısı.',
  tabs: {
    overview: 'Genel Bakış',
    customers: 'Müşteriler',
    products: 'Ürünler',
    geo: 'Bölgeler',
  },
  filters: {
    preset: 'Dönem',
    dateFrom: 'Başlangıç tarihi',
    dateTo: 'Bitiş tarihi',
    comparison: 'Karşılaştırma',
    granularity: 'Ayrıntı düzeyi',
    export: 'CSV dışa aktarımı',
    presets: {
      last30Days: 'Son 30 gün',
      currentMonth: 'Mevcut ay',
      lastMonth: 'Önceki ay',
      currentQuarter: 'İçinde bulunduğumuz çeyrek',
      currentYear: 'Cari yıl',
      lastYear: 'Önceki yıl',
      custom: 'Özel',
    },
    comparisons: {
      NONE: 'Karşılaştırma yok',
      PREVIOUS_PERIOD: 'Önceki dönem',
      PREVIOUS_YEAR: 'Geçen yılın aynı dönemi',
    },
    granularities: {
      DAY: 'Gün',
      WEEK: 'Hafta',
      MONTH: 'Ay',
      QUARTER: 'Çeyrek',
    },
  },
  validation: {
    invalidRange: 'Başlangıç tarihi bitiş tarihinden önce olmalıdır.',
  },
  states: {
    error: 'Analiz yüklenemedi.',
    empty: 'Seçilen dönemde veri yok',
    emptyHint: 'Analitiği görmek için dönemi ayarlayın veya belgeleri kaydedin.',
  },
  export: {
    success: 'Dışa aktarma oluşturuldu.',
  },
  kpi: {
    netRevenue: 'Net gelir',
    grossProfit: 'Brüt kar',
    marginPct: 'Marj',
    averageOrderValue: 'Ort. sipariş değeri',
    invoiceCount: 'Faturalar',
    activeCustomers: 'Aktif müşteriler',
    openReceivables: 'Açık alacaklar',
    cancelledOrderRatePct: 'İptal oranı\nKarşılaştırma dönemine kıyasla',
    comparedToPrevious: '',
  },
  charts: {
    revenueTitle: 'Gelir eğilimi',
    netRevenue: 'Net gelir',
    grossProfit: 'Brüt kar',
    orderIntake: 'Sipariş alımı',
    comparisonRevenue: 'Karşılaştırma dönemi',
  },
  payment: {
    title: 'Fatura ödeme durumu',
    paid: 'Ödendi',
    open: 'Aç',
    overdue: 'Vadesi geçmiş',
  },
  customers: {
    abcClass: 'Sınıf {{abcClass}}',
    abcSummary: '{{count}} müşterileri · {{share}} gelir paylaşımı',
    atRisk: 'Kaybolma riskiyle karşı karşıya',
    industryTitle: 'Sektöre göre gelir',
    tableTitle: 'Müşteri analizi',
    columns: {
      customer: 'Müşteri',
      industry: 'Endüstri',
      netRevenue: 'Net gelir',
      grossProfit: 'Brüt kar',
      margin: 'Marj',
      orders: 'Siparişler',
      lastOrder: 'Son sipariş',
      abc: 'ABC',
      churn: 'Kayıp',
    },
    churn: {
      NONE: 'Sağlıklı',
      WARNING: 'İzle',
      CRITICAL: 'Kritik',
    },
  },
  products: {
    groupTitle: 'Ürün grubuna göre katkı marjı I',
    tableTitle: 'Ürün analizi',
    slowMoverTitle: 'Yavaş hareket edenler',
    totals: {
      netRevenue: 'Net gelir',
      costOfGoods: 'Malların maliyeti',
      contributionMargin1: 'Katkı marjı I',
      productCount: 'Ürünler',
    },
    columns: {
      product: 'Ürün',
      group: 'Ürün grubu',
      quantity: 'Adet',
      netRevenue: 'Net gelir',
      contributionMargin1: 'CM I',
      contributionMargin2: 'CM II',
      margin: 'Marj',
      returnRate: 'Geri dönüş oranı',
      stockQuantity: 'Hisse Senedi',
      stockValue: 'Hisse senedi değeri',
      lastMovement: 'Son hareket',
      daysSinceMovement: 'Hareketsiz geçen günler',
    },
  },
  geo: {
    regionTitle: 'Bölgeye göre gelir',
    regionTableTitle: 'Bölgeler',
    countryTitle: 'Ülkeye göre gelir',
    regions: {
      DOMESTIC: 'Yurtiçi',
      EU: 'AB',
      THIRD_COUNTRY: 'AB dışı',
    },
    columns: {
      region: 'Bölge',
      country: 'Ülke',
      netRevenue: 'Net gelir',
      documents: 'Belgeler',
      customers: 'Müşteriler',
      share: 'Paylaş',
    },
  },
};
